import CheckboxUncontrolled from "../../components/CheckboxUncontrolled";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

const HotelChangesForm = ({ changes, changes2, msg, submit }) => {
  return (
    <>
      <p>
        Use this page to review occupant name changes or deletions after a
        request is confirmed. Checking accept will acknowedge the change and
        remove its pending status.
      </p>

      <form
        method="post"
        action="/"
        onSubmit={(e) => submit(e)}
        className="well"
        style={{ marginTop: "10px" }}
        id="changes-form"
      >
        <h4
          style={{
            marginTop: "0",
            lineHeight: "22px",
            marginBottom: "10px",
            fontSize: "1.1rem",
          }}
        >
          Pending Name Changes
        </h4>

        <table
          className="approved bulk"
          style={{ marginTop: "15px", marginBottom: "0px" }}
        >
          <thead>
            <tr>
              <th style={{ width: "15%" }}>Date</th>
              <th style={{ width: "17.5%" }}>ID</th>
              <th>Name Change</th>
              <th style={{ width: "15%" }}>Accept</th>
            </tr>
          </thead>

          {changes.length > 0 ? (
            <tbody>
              {changes.map((item) => {
                return (
                  <tr key={item.id}>
                    <td>{item.date}</td>
                    <td>{item.idStr}</td>
                    <td>{item.name}</td>
                    <td className="center">
                      <CheckboxUncontrolled
                        name="changeId[]"
                        value={item.id}
                        checked={false}
                        disabled={false}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td
                  colSpan="4"
                  className="working"
                  style={{ padding: "7.5px" }}
                >
                  -- no pending name changes --
                </td>
              </tr>
            </tbody>
          )}
        </table>

        <h4
          style={{
            marginTop: "20px",
            lineHeight: "22px",
            marginBottom: "10px",
            fontSize: "1.1rem",
          }}
        >
          Pending Deletions
        </h4>

        <table
          className="approved bulk"
          style={{ marginTop: "15px", marginBottom: "0px" }}
        >
          <thead>
            <tr>
              <th style={{ width: "15%" }}>Date</th>
              <th style={{ width: "17.5%" }}>ID</th>
              <th>Delete Details</th>
              <th style={{ width: "15%" }}>Accept</th>
            </tr>
          </thead>

          {changes2.length > 0 ? (
            <tbody>
              {changes2.map((item) => {
                return (
                  <tr key={item.id}>
                    <td>{item.date}</td>
                    <td>{item.idStr}</td>
                    <td>{item.name}</td>
                    <td className="center">
                      <CheckboxUncontrolled
                        name="changeId[]"
                        value={item.id}
                        checked={false}
                        disabled={false}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td
                  colSpan="4"
                  className="working"
                  style={{ padding: "7.5px" }}
                >
                  -- no pending deletions --
                </td>
              </tr>
            </tbody>
          )}
        </table>

        {(changes.length > 0 || changes2.length > 0) && (
          <div className="msg-submit">
            {msg.type && <Msg data={msg} />}

            <div
              className={
                msg.type === "working" || msg.type === "success"
                  ? "hidden"
                  : "submit-container"
              }
            >
              <Submit path="" left="" submit="Submit Changes" />
            </div>
          </div>
        )}
      </form>
    </>
  );
};

export default HotelChangesForm;
